module.exports = __webpack_public_path__ + "img/item_details_cart.f5571684.png";